import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { v4 as uuidv4 } from "uuid";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function isStringEmpty(str: string | null | undefined): boolean {
  return str === null || str === undefined || str.trim() === "";
}

export function isStringNotEmpty(str: string | null | undefined): boolean {
  return !isStringEmpty(str);
}

// crypto.randomUUID() is only available secure environments (https). This is a fallback for unsecure environments.
export function uuid() {
  return uuidv4();
}

export function toTitleCase(str: string) {
  return str.replace(/\w\S*/g, (text) => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase());
}

export function replaceAll(str: string, find: string, replace: string) {
  return str.replace(new RegExp(find, "g"), replace);
}

export function camelCaseToTitleCase(str: string) {
  return str.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/\b\w/g, (word) => word.toUpperCase());
}
